import defaultPipeline from './defaultPipeline'

const makeTheme = (variables, pipeline) => {
  const finalizer = pipeline || defaultPipeline

  return finalizer(variables)
}

export default makeTheme
